import {Component, Input} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
             selector: 'app-filter',
             templateUrl: './home-assistance-list-filter.component.html'
           })
export class HomeAssistanceListFilterComponent {

  @Input() label: string | undefined;
  @Input() allLabel: string | undefined;
  @Input() noLabel: string | undefined;
  @Input() dataToggle: string | undefined;
  @Input() source: Array<any> | undefined;


  constructor(private translateService: TranslateService) {
  }

  getSelectedValues(): string {
    if (this.source?.every(this.isAllToggled)) {
      return this.allLabel ? this.allLabel : this.translateService.instant('all', {type: 'plural_female'});
    }
    if (this.source?.every(this.isNoneToggled)) {
      return this.noLabel ? this.noLabel : this.translateService.instant('none', {type: 'singular_female'});
    }
    let selected = '';
    if (this.source) {
      for (const item of this.source) {
        if (item.toggle) {
          selected = selected.concat(item.label + ', ');
        }
      }
      selected = selected.substring(0, selected.length - ', '.length);
    }
    return selected;
  }

  private isAllToggled(currentValue: any): boolean {
    return currentValue.toggle;
  }

  private isNoneToggled(currentValue: any): boolean {
    return !currentValue.toggle;
  }
}
